import React from 'react';

const BackDrop = props =>{
	if(props.active) {
		return <div className="backdrop"/>
	} else {
		return null;
	}	
}

export default BackDrop;